<div class="comment-template" @click="closePersonDropdown">
  <div class="page-header">
    <h2>评论模板管理</h2>
    <button type="button" class="primary-btn" @click="openCreateModal">新增模板</button>
  </div>

  <div class="filter-panel">
    <div class="filter-row">
      <div class="filter-item">
        <label>内容搜索</label>
        <input
          v-model="keyword"
          type="search"
          placeholder="按评论内容模糊搜索"
          autocomplete="off"
          @input="handleSearchInput"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="filter-item filter-item-narrow">
        <label>适用范围</label>
        <select v-model="filterScope">
          <option value="">全部</option>
          <option value="global">全局</option>
          <option value="person">个人</option>
        </select>
      </div>
      <div class="filter-item filter-item-narrow">
        <label>分类</label>
        <input v-model="filterCategory" type="text" placeholder="如：思念" />
      </div>
      <div class="filter-item filter-item-narrow">
        <label>纪念人 ID</label>
        <input v-model="filterPersonId" type="number" min="1" step="1" placeholder="person_id" />
      </div>
      <div class="filter-item filter-item-narrow">
        <label>状态</label>
        <select v-model="filterState">
          <option value="1">有效</option>
          <option value="0">已删</option>
          <option value="">全部</option>
        </select>
      </div>
    </div>
    <div class="filter-actions">
      <button type="button" class="search-btn" :disabled="loading" @click="handleSearch">查询</button>
      <button type="button" class="secondary-btn" :disabled="loading" @click="resetFilters">重置</button>
    </div>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <table v-else class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>适用范围</th>
          <th>纪念人 ID</th>
          <th>分类</th>
          <th>评论内容</th>
          <th>排序</th>
          <th>状态</th>
          <th>创建时间</th>
          <th>更新时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="templateList.length === 0">
          <td colspan="10" class="empty-text">暂无评论模板</td>
        </tr>
        <tr v-else v-for="item in templateList" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ pickScopeLabel(item.scope) }}</td>
          <td>{{ item.scope === 'person' ? (item.person_id ?? '-') : '-' }}</td>
          <td>{{ item.category || '-' }}</td>
          <td>{{ item.content }}</td>
          <td>{{ item.sort_order ?? '-' }}</td>
          <td>
            <span :class="item.state === 1 ? 'state-active' : 'state-deleted'">
              {{ pickStateLabel(item.state) }}
            </span>
          </td>
          <td>{{ item.created_at || '-' }}</td>
          <td>{{ item.updated_at || '-' }}</td>
          <td class="action-column">
            <button type="button" class="action-btn edit-btn" :disabled="saving" @click="openEditModal(item)">
              编辑
            </button>
            <button
              v-if="item.state === 1"
              type="button"
              class="action-btn delete-btn"
              :disabled="saving"
              @click="handleDelete(item)"
            >
              删除
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="!loading && templateList.length > 0" class="pagination">
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage <= 1"
        @click="handlePageChange(currentPage - 1)"
      >
        上一页
      </button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条</span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop @click="closePersonDropdown">
      <div class="modal-header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="close-btn" @click="closeModal">×</button>
      </div>

      <div v-if="detailLoading" class="modal-loading">加载详情中...</div>
      <div v-else class="modal-body">
        <div class="form-row">
          <label>适用范围 <span class="required">*</span></label>
          <div class="scope-options">
            <label class="radio-label">
              <input v-model="form.scope" type="radio" value="global" />
              全局
            </label>
            <label class="radio-label">
              <input v-model="form.scope" type="radio" value="person" />
              个人
            </label>
          </div>
        </div>

        <div v-if="form.scope === 'person'" class="form-row" @click.stop>
          <label>纪念人 <span class="required">*</span></label>
          <div class="person-picker">
            <input
              v-model="personSearchQuery"
              type="search"
              placeholder="搜索纪念人姓名"
              autocomplete="off"
              @input="handlePersonSearch"
              @focus="personDropdownOpen = true"
            />
            <button
              v-if="selectedPerson"
              type="button"
              class="clear-btn"
              @click="clearSelectedPerson"
            >
              清除
            </button>
            <div
              v-if="personDropdownOpen && (personSearchLoading || personSearchResults.length > 0)"
              class="person-dropdown"
            >
              <div v-if="personSearchLoading" class="dropdown-hint">搜索中...</div>
              <button
                v-for="person in personSearchResults"
                :key="person.id"
                type="button"
                class="dropdown-item"
                @click="selectPerson(person)"
              >
                {{ person.name }}（ID: {{ person.id }}）
              </button>
            </div>
            <div v-if="selectedPerson" class="selected-person">
              已选：{{ selectedPerson.name }}（ID: {{ selectedPerson.id }}）
            </div>
          </div>
        </div>

        <div class="form-row">
          <label>分类</label>
          <input v-model="form.category" type="text" placeholder="例如：思念、祈福" maxlength="50" />
        </div>
        <div class="form-row">
          <label>评论内容 <span class="required">*</span></label>
          <input v-model="form.content" type="text" placeholder="例如：永远怀念您" maxlength="200" />
        </div>
        <div class="form-row-inline">
          <div class="form-row form-row-narrow">
            <label>排序</label>
            <input v-model.number="form.sort_order" type="number" min="0" step="1" />
          </div>
          <div class="form-row form-row-narrow">
            <label>状态</label>
            <select v-model.number="form.state">
              <option :value="1">有效</option>
              <option :value="0">禁用</option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button type="button" class="secondary-btn" :disabled="saving || detailLoading" @click="closeModal">
          取消
        </button>
        <button type="button" class="primary-btn" :disabled="saving || detailLoading" @click="handleSave">
          {{ saving ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</div>
